import React from "react";

export default function Box({ children }) {
    return (
        <div className="shadow-4xl mx-5 my-10 py-5 rounded-sm xl:mx-36 sm:py-10">
            {children}
        </div>
    );
}
